// This is only here for backwards compatibility
export * from './recorder'
